module.exports = __webpack_public_path__ + "img/Bag Icon - white.17622ce0.svg";